import { Fragment, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import type { AccordionProps } from './Accordion.types';
import './Accordion.scss';

export default function Accordion({ items, multiple = false, defaultOpen = [], className }: AccordionProps) {
  const [open, setOpen] = useState<Set<string>>(new Set(defaultOpen));

  const toggle = (id: string) => {
    setOpen(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else {
        if (!multiple) next.clear();
        next.add(id);
      }
      return next;
    });
  };

  return (
    <div className={['accordion', className || ''].filter(Boolean).join(' ')}>
      {items.map((it, idx) => {
        const isOpen = open.has(it.id);
        const headerId = `acc-h-${it.id}`;
        const panelId = `acc-p-${it.id}`;
        return (
          <Fragment key={it.id}>
            {idx > 0 ? <div role="separator" className="accordion__divider" /> : null}
            <div className={['accordion__item', isOpen ? 'accordion__item--open' : ''].filter(Boolean).join(' ')}>
            <h3 className="accordion__heading">
              <button
                id={headerId}
                type="button"
                aria-expanded={isOpen}
                aria-controls={panelId}
                disabled={it.disabled}
                className="accordion__trigger"
                onClick={() => toggle(it.id)}
              >
                <span className="accordion__title">{it.title}</span>
                <span className="accordion__chev" aria-hidden="true"><ChevronDown size={18} /></span>
              </button>
            </h3>
            <div
              id={panelId}
              role="region"
              aria-labelledby={headerId}
              hidden={!isOpen}
              className="accordion__panel"
            >
              <div className="accordion__panel-inner">{it.content}</div>
            </div>
            </div>
          </Fragment>
        );
      })}
    </div>
  );
}
